import { RootState } from '../../store/root-state';

export const getProductPackageState = (state: RootState) => state.productPackage.productPackage;
